import React from "react";
import { Provider } from "react-redux";
import store from "src/store";
import router from "./Routes";
import { RouterProvider } from "react-router/dom";
import { HotelPrebookProgress } from "src/components/features/hotel-preview/HotelPrebookProgress/HotelPrebookProgress";

function App() {
  return (
    <Provider store={store}>
      <RouterProvider
        router={router}
        fallbackElement={
          <HotelPrebookProgress
            forceVisible={window.location.pathname.startsWith("/search/hotels/preview/")}
          />
        }
      />
    </Provider>
  );
}

export default App;
